import Badge from '@shared/components/Badge';
import { severityLabel, severityTone } from '@/lib/eventTypeLabels';

/**
 * La severidad de un evento del Registro. Recibe la de la FILA, que puede no ser
 * la del tipo (`emit` acepta otra y `emit_failure` la sube a error). `critical`
 * comparte tono con `error` y se distingue por el icono.
 */
export default function EventSeverityBadge({ severity }: { severity: string | null | undefined }) {
  if (!severity) return null;
  const label = severityLabel(severity);
  return (
    <Badge tone={severityTone(severity)} icon={severity === 'critical' ? 'priority_high' : undefined} title={label}>
      {label}
    </Badge>
  );
}
